import * as React from 'react';

import Tooltip from 'components/Tooltip';
import SVGDynamicIcon from 'components/svg-dynamic-icon/SVGDynamicIcon';

import { __t, applyTranslations } from 'utils/language';

import './shipping-addresses-download-button.scss';

applyTranslations(require('./shipping-addresses-download-button.i18n.json'));

type Props = {
  onClick: () => void
};

const ShippingAddressesDownloadButton = (
  {
    onClick
  }: Props
): JSX.Element => (
  <Tooltip
    message={__t('shipping_addresses_download_button.tooltip')}
    width="auto-compact"
  >
    <div className="shipping-addresses-download-button">
      <SVGDynamicIcon
        onClick={onClick}
        name="download-custom-fg"
        customColor="grey"
        width={20}
        height={20}
      />
    </div>
  </Tooltip>
);

export default ShippingAddressesDownloadButton;
